import { getLandingPagesAffiliateLinks } from "../api";
import { affiliateLinkDetailsKeys } from "./keys";
import { useAffiliateLinkDetailQuery } from "./use-affiliate-link-detail-query";

export const useAffiliateLinkLandingPagesQuery = (id, enabled = true) =>
  useAffiliateLinkDetailQuery({
    queryKey: affiliateLinkDetailsKeys.landingPages(id),
    fetcher: getLandingPagesAffiliateLinks,
    id,
    dataKey: "affiliateLinksWithLandingPages",
    enabled,
  });
